import styles from './Footer.module.css'

export default function Footer() {
  return (
    <div className={styles.footer}>
        <p> &#169; Macaraig, 2022 All right reserved.</p>
    </div>
  );
}
